module.exports = __webpack_public_path__ + "media/images/icon-subtract-f46b15803d81313423a8c6e502779860.svg";